module.exports = __webpack_public_path__ + "img/phone.46096e05.png";